module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }